import React from "react";
import { Spinner } from "@heroui/react";

export function LoadingState({ label = "Loading…" }) {
  return (
    <div className="portal-page flex flex-col items-center justify-center gap-3 py-16">
      <Spinner aria-label={label} />
      <p className="text-sm text-[var(--muted)]">{label}</p>
    </div>
  );
}
